import React from "react";
import ListKpiController from "./ListKpiController";

export default function ListKpiCarbonController() {

    return (
        <ListKpiController
            categoria={3}
        />
    );
}
